import { FeatureAppDefinition, FeatureServices, Logger } from '@feature-hub/core';
import { ReactFeatureApp } from '@feature-hub/react';
import React from 'react';
import { App } from './app';
import { FeatureServicesContext } from './use-feature-services';
import dependencies from './dependencies.json';
import { HistoryServiceV3 } from '@feature-hub/history-service';
import { ServerRequestV1 } from '@feature-hub/server-request';
import { AsyncSsrManagerV1 } from '@feature-hub/async-ssr-manager';
import { SerializedStateManagerV1 } from '@feature-hub/serialized-state-manager';
import { ApiKeyProviderV1 } from '@volkswagen-onehub/api-key-provider';
import { DisclaimerManagerV1 } from '@volkswagen-onehub/disclaimer-manager';
import { FaContentServiceV1 } from '@volkswagen-onehub/fa-content-service';
import { LayerManagerV24 } from '@volkswagen-onehub/layer-manager';
import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { PageInfoServiceV1 } from '@volkswagen-onehub/page-info-service';
import { BreadcrumbServiceV1 } from '@volkswagen-onehub/breadcrumb-service';
import { ThemeProvider } from '@volkswagen-onehub/components-core';
import { CommonFeatureAppConfig } from '@volkswagen-onehub/vw-starter-feature-app-support';
import { ServiceConfigEndpointProvider } from '@volkswagen-onehub/service-config-endpoint-provider';
import { FeatureappServiceV1 } from '@volkswagen-onehub/featureapp-service';
import { NavigationServiceV1 } from '@volkswagen-onehub/navigation-service';

export interface StarterFeatureAppDependencies extends FeatureServices {
  readonly 'api-key-provider'?: ApiKeyProviderV1;
  readonly 'disclaimer-manager': DisclaimerManagerV1;
  readonly 'fa-content-service'?: FaContentServiceV1;
  readonly 'layer-manager': LayerManagerV24;
  readonly 'locale-service': LocaleServiceV1;
  readonly 's2:history': HistoryServiceV3;
  readonly 's2:logger'?: Logger;
  readonly 's2:server-request'?: ServerRequestV1;
  readonly 'service-config-endpoint-provider': ServiceConfigEndpointProvider;
  readonly 'page-info-service': PageInfoServiceV1;
  readonly 'breadcrumb-service': BreadcrumbServiceV1;
  readonly 's2:serialized-state-manager': SerializedStateManagerV1;
  readonly 's2:async-ssr-manager': AsyncSsrManagerV1;
  readonly 'featureapp-service': FeatureappServiceV1;
  readonly 'navigation-service': NavigationServiceV1;
}

export const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  StarterFeatureAppDependencies,
  CommonFeatureAppConfig
> = {
  ...dependencies,

  create: (env) => {
    const { featureServices } = env;

    return {
      // eslint-disable-next-line react/display-name
      render: () => {
        return (
          <FeatureServicesContext.Provider value={featureServices}>
            <ThemeProvider theme="main">
              <App />
            </ThemeProvider>
          </FeatureServicesContext.Provider>
        );
      },
    };
  },
};

export default featureAppDefinition;
